import { render, staticRenderFns } from "./ReviewLaneClosureRequestBlockRestrictionListing.vue?vue&type=template&id=062ba350&"
import script from "./ReviewLaneClosureRequestBlockRestrictionListing.vue?vue&type=script&lang=js&"
export * from "./ReviewLaneClosureRequestBlockRestrictionListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports